import { CleaveInput } from "@interface48/form-controls";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { processValue } from "../utils";
import { WidgetProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    inputLeftAligned: {
      textAlign: "left",
    },
    inputRightAligned: {
      textAlign: "right",
    },
  });

interface PhoneNumberWidgetProps extends WidgetProps<string | number>, WithStyles<typeof styles> {
  options: {
    inputTextAlignment?: "left" | "center" | "right";
  };
}

export const PhoneNumberWidgetComponent = (props: PhoneNumberWidgetProps) => {
  const { id, schema, options: uiOptions, required, placeholder, value, onChange, classes } = props;
  const inputTextAlignment = (uiOptions && uiOptions.inputTextAlignment) || "left";

  const processPhoneNumberValue = (value: string | number | undefined | null) => {
    return processValue(value, schema.type, required) as string | number | null | undefined;
  };

  const rootClassName = classNames(
    classes.root,
    inputTextAlignment === "left" ? classes.inputLeftAligned : classes.inputRightAligned,
  );

  return (
    <CleaveInput
      id={id}
      placeholder={placeholder}
      value={value as string}
      processValue={processPhoneNumberValue}
      onChange={onChange}
      className={rootClassName}
      cleaveOptions={{ phone: true, phoneRegionCode: "CA", delimiter: "-" }}
    />
  );
};

export const PhoneNumberWidget = withStyles(styles)(PhoneNumberWidgetComponent);
